import request from '@/utils/request'

/**
 * 获取配置项列表数据
 */
export const getAppkitOptionLists = (data) => {
    return request({
        url: '/appkit/lists',
        params: data
    })
}
/**
 * 获取配置项列表数据
 */
export const getConfigItemOptions = (data) => {
    return request({
        url: '/appkit/option/lists',
        params: data
    })
}

/**
 * 删除
 */
export const delAppkit = (id) => {
    return request({
        url: `/appkit/${id}`,
        method: 'DELETE'
    })
}
/**
 * 编辑
 */
export const putAppkit = (data) => {
    return request({
        url: '/appkit/manage',
        method: 'PUT',
        data
    })
}
/**
 * 添加
 */
export const addAppkit = (data) => {
    return request({
        url: '/appkit/manage',
        method: 'POST',
        data
    })
}

/**
 * 详情
 */
export const getAppkitDetail = (id) => {
    return request({
        url: `/appkit/${id}`
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/appkit/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}

// 批量设置值
export const batchSetting = (data) => {
    return request({
        url: '/config/manage',
        method: 'PATCH',
        data: {
            method: 'batch_setting',
            data
        }
    })
}
